import React from 'react';
import {Row} from "antd";

function Loading() {
    return (
        <Row justify={"center"} align={'middle'} className="loading logo-dark-bg h-full w-full">
            <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 176.06 175.86"
                 className="h-[50vh]">
                <defs>
                    <linearGradient xmlns="http://www.w3.org/2000/svg" id="linear-gradient" x1="88.03" y1="0" x2="88.03"
                                    y2="175.86" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stopColor="#5cc5f1"></stop>
                        <stop offset=".24" stopColor="#58c2ef"></stop>
                        <stop offset=".44" stopColor="#4eb8e9"></stop>
                        <stop offset=".63" stopColor="#3da8df"></stop>
                        <stop offset=".8" stopColor="#2492d1"></stop>
                        <stop offset=".97" stopColor="#0576bf"></stop>
                        <stop offset="1" stopColor="#0071bc"></stop>
                    </linearGradient>
                </defs>
                <g id="Layer_1-2" data-name="Layer 1" transform="scale(0.8) translate(20, 20)">
                    <path className="first-column" d="m22.43,175.86L0,164.26v-64.92l22.43,12v64.52Z"></path>
                    <path className="second-column" d="m51.49,61.77l-22.43-12v109.37l22.43,11.61V61.77Z"></path>
                    <path className="third-column" d="m83.16,12l-22.43-12v154.03l22.43,11.61V12Z"></path>
                    <path className="forth-column" d="m114.24,69.44l-22.43-12v91.87l22.43,11.61v-91.47Z"></path>
                    <path className="fifth-column" d="m144.73,36.39l-22.43-12v119.8l22.43,11.61V36.39Z"></path>
                    <path className="sixth-column" d="m173.64,79.57l-22.43-12v70.92l22.43,11.61v-70.52Z"></path>
                </g>
            </svg>
        </Row>
    );
}

export default Loading;
